module.exports = __webpack_public_path__ + "img/img-5.d7e91f99.png";